import { render, staticRenderFns } from "./SentNotificationPopup.vue?vue&type=template&id=796b32c6&scoped=true&"
import script from "./SentNotificationPopup.vue?vue&type=script&lang=js&"
export * from "./SentNotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./SentNotificationPopup.vue?vue&type=style&index=0&id=796b32c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b32c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796b32c6')) {
      api.createRecord('796b32c6', component.options)
    } else {
      api.reload('796b32c6', component.options)
    }
    module.hot.accept("./SentNotificationPopup.vue?vue&type=template&id=796b32c6&scoped=true&", function () {
      api.rerender('796b32c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Group/components/notification/SentNotificationPopup.vue"
export default component.exports